import BonusWagers from "./bonus-wagers";

export default BonusWagers;
